export default "__VITE_ASSET__3354b8b8__"